import { render, staticRenderFns } from "./POS-employees.vue?vue&type=template&id=693f38c3"
import script from "./POS-employees.vue?vue&type=script&lang=js"
export * from "./POS-employees.vue?vue&type=script&lang=js"
import style0 from "./POS-employees.vue?vue&type=style&index=0&id=693f38c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports